<template>
  <CustomizerForm
    v-if="instance"
    :value="instance"
    :breadcrumbs="breadcrumbs"
  >
    <template #actions="{form, fields, isEqual}">
      <VButtonDialog @confirm="remove(fields)">
        Delete
      </VButtonDialog>
      <v-btn
        :disabled="!form || isEqual"
        color="success"
        class="mx-2"
        rounded
        @click="update(fields)"
      >
        Save
      </v-btn>
    </template>
  </CustomizerForm>
</template>

<script>
import { Customizer } from '@/store/models'
import VButtonDialog from '@/components/VButtonDialog'
import removeMixin from '@/mixins/apiRemoveMixin'
import updateMixin from '@/mixins/apiUpdateMixin'
import { mapGetters } from 'vuex'
import CustomizerForm from '@/pages/App/MenuCreator/Customizers/__CustomizerForm__'

export default {
  name: 'CustomizerId',
  components: { CustomizerForm, VButtonDialog },
  mixins: [removeMixin(Customizer), updateMixin(Customizer)],
  computed: {
    ...mapGetters('app', ['customizers']),
    breadcrumbs () {
      return [
        {
          text: 'Categories',
          exact: true,
          to: { name: 'App-MenuCreator-Customizers' }
        },
        {
          text: this.instance.name,
          exact: true,
          to: { name: 'App-MenuCreator-Customizers-id', params: { id: this.instance.id } }
        }
      ]
    },
    instance () {
      const customizer = this.customizers.find(this.$route.params.id)
      if (customizer?.customizerItems) {
        customizer.customizerItems.sort((x, y) => x.rank - y.rank)
      }
      return customizer
    }
  }
}
</script>
